export const delayPush = (history, state) => {
  setTimeout(() => {
    history.push(state);
  }, 300);
};

export const delayReplace = (history, state) => {
  setTimeout(() => {
    history.replace(state);
  }, 300);
};

export const isIllegalOparation = (location) => location.state === undefined;

export const checkDoneItem = (state) =>
  state === "予定通り実施" || state === "予定なし実施" || state === "時間変更";
